import { render, staticRenderFns } from "./PaySchedulesInvalidBankDetails.vue?vue&type=template&id=798e44f1&"
import script from "./PaySchedulesInvalidBankDetails.vue?vue&type=script&setup=true&lang=js&"
export * from "./PaySchedulesInvalidBankDetails.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports